import { useEffect, useState } from "react";

let promise;
const load = () => {
  if (!promise) {
    promise = fetch(`${process.env.REACT_APP_BACKEND_URL}/api/google-reviews`).then((r) =>
      r.ok ? r.json() : Promise.reject(new Error("reviews unavailable"))
    );
  }
  return promise;
};

export const useGoogleReviews = () => {
  const [data, setData] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    load().then(setData).catch(() => setFailed(true));
  }, []);
  return { data, failed };
};
